<template>
  <div>
    <span>{{ msg }}</span>
  </div>
</template>

<script>
export default {
    name: "OAUTH",
    data() {
        return {
            msg: '正在获取信息...',
            authData: {},
        }
    },
    mounted(){
        window.title = this.$route.meta.title
        switch (this.$route.params.service) {
            case 'qq':
                this.checkQQ()
                break;
            default:
                break;
        }
    },
    methods: {
        checkQQ() {
            if(QC.Login.check()){
                //登陆成功
                this.msg = 'login success. calling back the underlying information.';
            }else{
                //失败
                this.msg = 'login fail.';
            }
        },
        checkGithub(){

        },
        closeWindow(){
        }
    },
}
</script>
